<div class="card-container">
  @if (this.styleOption?.customIconSrc) {
    <img
      [class.flexstart-type-icon]="!this.styleOption?.iconCenterAlign"
      [src]="this.styleOption?.customIconSrc!"
      [width]="24"
      [height]="24"
      alt="Icon information"
    />
  } @else {
    <app-icon
      [class.flexstart-type-icon]="!this.styleOption?.iconCenterAlign"
      [phosphorClass]="getType.iconClass"
      [color]="getType.color"
    ></app-icon>
  }

  <div class="card-body">
    <div class="content">
      @if (title) {
        <span id="alertTitle">{{ title }}</span>
      }
      @if (description) {
        <p id="alertDescription" [innerHTML]="description"></p>
      }
      @if (actionText) {
        <app-button class="action-btn" (click)="actionCallback?.()" [size]="ButtonSize.Small" >{{ actionText }}</app-button>
      }
    </div>
    @if (closeIcon) {
      <app-button
        class="close-btn"
        buttonId="closed-alert-btn"
        [size]="ButtonSize.Small"
        [style]="ButtonStyle.Textual"
        [iconOptions]="{ phosphorClass: 'ph-x', position: ButtonIcon.OnlyIcon }"
        (onclick)="closeEvent.emit()"
      >
      </app-button>
    }
  </div>
</div>
